import { createAction, handleActions } from 'redux-actions';

export const setMaintenanceMessage = createAction('SET_MAINTENANCE_MESSAGE');

const defaultState = null;

export const messageReducer = handleActions(
  {
    [setMaintenanceMessage]: (state, action) => action.payload?.message ?? null
  },
  defaultState
);

export const showUntilTimeReducer = handleActions(
  {
    [setMaintenanceMessage]: (state, action) => action.payload?.showUntilTime ?? null
  },
  defaultState
);

// Backward compatibility
export const reducer = messageReducer;
